// extracted by mini-css-extract-plugin
export default {"visibleAreaImage":"styles_visibleAreaImage__BDVej","image":"styles_image__Z5Qao"};